<template>
  <div class="reportDetail">
    <!-- <h3 class="mb-2">제조기록지 상세</h3> -->
    <SetPopup ref="confirm" />

    <div class="filter-box filter-box--row mt-2">
      <ul class="filter-list03">
        <li>
          <h4>Lot No</h4>
          <v-text-field outlined dense disabled filled v-model="param.lotNo"></v-text-field>
        </li>
        <li>
          <h4>Code Grade</h4>
          <!-- 표기만 원산지 제한 접미사를 붙인다. 저장·조회 파라미터는 param.code(원본) 그대로다. -->
          <v-text-field outlined dense disabled filled :value="displayCodeGrade"></v-text-field>
        </li>
        <li>
          <h4>수량(Qty)</h4>
          <v-text-field outlined dense disabled filled suffix="kg" v-model="param.qty"></v-text-field>
        </li>
        <li>
          <h4>출하예정일</h4>
          <v-text-field outlined dense disabled filled v-model="param.out_due_date"></v-text-field>
        </li>
        <li>
          <h4>요청업체명</h4>
          <v-text-field outlined dense disabled filled v-model="param.request_company"></v-text-field>
        </li>
        <li>
          <h4>요청인</h4>
          <v-text-field outlined dense disabled filled v-model="param.request_name"></v-text-field>
        </li>
        <li>
          <h4>조성</h4>
          <v-text-field outlined dense disabled filled v-model="param.code_title"></v-text-field>
        </li>
      </ul>
      <!-- <v-row class="px-2">
        <v-col cols="12" sm="2">
          <h4>Lot No</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.lotNo"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <h4>Code Grade</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            :value="displayCodeGrade"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <h4>수량(Qty)</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.qty"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <h4>출하예정일</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.out_due_date"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <h4>요청업체명</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.request_company"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2">
          <h4>요청인</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.request_name"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col cols="12" sm="12">
          <h4>조성</h4>
          <v-text-field
            outlined
            dense
            disabled
            filled
            v-model="param.code_title"
          ></v-text-field>
        </v-col>
      </v-row> -->
    </div>
    <!-- <h3 class="mt-4 mb-2">세부정보</h3> -->
    <!-- <hr class="mb-8" /> -->
    <RealGrid :domName="grid" ref="reportDetailGrid" :settings="settings" :nonePage="true" class="mb-2" @changeData="changeData" />
    <div class="filter-box--row mt-6">
      <div class="filter-box" style="width: 40%">
        <ul class="filter-list_address">
          <li>
            <h4>포장 용기</h4>
            <v-select :items="this.rmAll(code.C)" v-model="param.packing" placeholder="선택해주세요" outlined id="work" disabled filled></v-select>
          </li>
          <li style="padding-top: 30px">
            <h4>라벨 기재사항</h4>
            <v-text-field outlined dense v-model="param.request_code" disabled filled></v-text-field>
          </li>
          <li style="padding-top: 30px">
            <h4>배송방법</h4>
            <v-select :items="this.rmAll(code.D)" v-model="param.delivery_type" placeholder="선택해주세요" outlined id="work" disabled filled></v-select>
          </li>
          <li style="padding-top: 30px">
            <h4>총량</h4>
            <div class="total-row">
              <v-text-field outlined dense hide-details :suffix="totalUnit" :value="totalDisplay" @input="onTotalInput"></v-text-field>
              <v-btn class="total-unit-btn" outlined color="primary" @click="toggleTotalUnit">
                <v-icon left small>mdi-swap-horizontal</v-icon>
                <strong>{{ oppositeUnit }}</strong
                >로 변환
              </v-btn>
            </div>
            <div class="total-db-hint">
              <v-icon x-small>mdi-database</v-icon>
              DB 저장값 · {{ totalDbText }}
            </div>
          </li>
        </ul>
      </div>
      <div class="filter-box">
        <ul class="filter-list_address">
          <li>
            <h4>분석 특이사항</h4>
            <v-text-field outlined dense v-model="param.analysis" disabled filled></v-text-field>
          </li>
          <li style="padding-top: 30px">
            <h4>고객요청 특이사항</h4>
            <v-text-field outlined dense v-model="param.request_etc" disabled filled></v-text-field>
          </li>
          <li style="padding-top: 30px">
            <h4>제조상 특이사항</h4>
            <v-text-field outlined dense v-model="param.produce_etc" disabled filled></v-text-field>
          </li>
          <li style="padding-top: 30px">
            <h4>포장 및 배송관련 특이사항</h4>
            <v-text-field outlined dense v-model="param.delivery_etc" disabled filled></v-text-field>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="filter-box filter-box__row">
      <ul class="filter-list03">
        <li>
          <h4>포장 용기</h4>
          <v-select
            :items="this.rmAll(code.C)"
            v-model="param.packing"
            placeholder="선택해주세요"
            outlined
            id="work"
          ></v-select>
        </li>
        <li>
          <h4>라벨기재사항</h4>
          <v-text-field
            outlined
            dense
            v-model="param.request_code"
          ></v-text-field>
        </li>
        <li>
          <h4>배송방법</h4>
          <v-select
            :items="this.rmAll(code.D)"
            v-model="param.delivery_type"
            placeholder="선택해주세요"
            outlined
            id="work"
          ></v-select>
        </li>
        <li>
          <h4>분석 특이사항</h4>
          <v-text-field outlined dense v-model="param.analysis"></v-text-field>
        </li>
        <li>
          <h4>고객요청 특이사항</h4>
          <v-text-field
            outlined
            dense
            class="pr-2"
            v-model="param.request_etc"
          ></v-text-field>
        </li>
        <li>
          <h4>제조상 특이사항</h4>
          <v-text-field
            outlined
            dense
            v-model="param.produce_etc"
          ></v-text-field>
        </li>
        <li>
          <h4>포장 및 배송관련 특이사항</h4>
          <v-text-field
            outlined
            dense
            v-model="param.delivery_etc"
          ></v-text-field>
        </li>
        <li>
          <h4>총량</h4>
          <v-text-field outlined dense v-model="param.total"></v-text-field>
        </li>
      </ul>
      <v-row style="height: 90px" class="px-2">
        <v-col cols="12" sm="3">
          <h4>포장 용기</h4>
          <v-select
            :items="this.rmAll(code.C)"
            v-model="param.packing"
            placeholder="선택해주세요"
            outlined
            id="work"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>라벨기재사항</h4>
          <v-text-field
            outlined
            dense
            v-model="param.request_code"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>배송방법</h4>
          <v-select
            :items="this.rmAll(code.D)"
            v-model="param.delivery_type"
            placeholder="선택해주세요"
            outlined
            id="work"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>분석 특이사항</h4>
          <v-text-field outlined dense v-model="param.analysis"></v-text-field>
        </v-col>
      </v-row>
      <v-row style="height: 90px" class="px-2">
        <v-col cols="12" sm="3">
          <h4>고객요청 특이사항</h4>
          <v-text-field
            outlined
            dense
            class="pr-2"
            v-model="param.request_etc"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>제조상 특이사항</h4>
          <v-text-field
            outlined
            dense
            v-model="param.produce_etc"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>포장 및 배송관련 특이사항</h4>
          <v-text-field
            outlined
            dense
            v-model="param.delivery_etc"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <h4>총량</h4>
          <v-text-field outlined dense v-model="param.total"></v-text-field>
        </v-col>
      </v-row>
      <v-row style="height: 90px" class="px-2"> </v-row>
    </div> -->
    <div class="wrapper">
      <div class="btn-box mb-2">
        <v-card-actions>
          <v-btn depressed class="btn-cancle" @click="reset">취소</v-btn>
        </v-card-actions>
        <v-card-actions>
          <v-btn depressed class="btn-confim" @click="save">완료 </v-btn>
        </v-card-actions>
      </div>
    </div>
  </div>
</template>
<script>
import RealGrid from '@/components/RealGrid.vue';
import SetPopup from '@/components/SetPopup.vue';
import _ from 'lodash';
import { mapState, mapMutations } from 'vuex';
import { produceReportDetail, produceReportUpdate } from 'api/sample/sample';
import * as settings from '@/assets/grid/reportDetail';
import { getNum } from '@/assets/grid/gridUtill';
import { displayCodeOf } from '@/assets/displayCode';
export default {
  props: ['data'],
  data() {
    return {
      isFetching: false,
      isDataLoaded: false, // 데이터 로드 완료 상태 추가
      isRevertingTotal: false, // 계산비 합계≠100일 때 총량 변경 되돌림 재진입 가드
      suppressTotalWatch: false, // 초기 로딩 등 프로그램적 총량 세팅 시 watch 무시 (watch는 nextTick에 실행되므로 isFetching로는 못 막음)
      grid: 'reportDetail',
      id: '',
      // 총량 표시 단위(g/kg). param.total은 항상 g(정수)로 유지하고 화면 표시값만 이 단위로 환산한다.
      totalUnit: 'g',
      totalDisplay: '',
      param: {
        lotNo: this.data.lotNo,
        code: this.data.code,
        qty: this.data.qty,
        out_due_date: this.data.out_due_date,
        request_company: this.data.request_company,
        request_name: this.data.request_name,
        code_title: '',
        delivery_type: '',
        analysis: '',
        delivery_etc: '',
        produce_etc: '',
        request_etc: '',
        detail: [],
        packing: '',
        request_code: '',
        sum_qty: '',
        sum_vol: '',
        sum_vol2: '',
        total: '',
        total_unit: '',
      },
      settings,
    };
  },
  methods: {
    ...mapMutations('popup', ['SET_POPUP', 'SET_POPUP_TEXT']),
    ...mapMutations('menu', ['REMOVE_SELECT_MENU', 'SET_SELECT_MENU_TAB_BY_CODE']),
    ...mapMutations('member', ['SET_USER_INFO']),
    openPopup(text, closable, cb, width = 300, title = '알림') {
      this.SET_POPUP({
        title,
        // height: 150,
        width,
        text,
        closable,
      });
      this.$refs.confirm.openPopup(cb);
    },
    // 계산비(제조조성) 합계가 100인지 검사. 100이 아니면 안내 팝업 후 false 반환
    checkCompositionSum() {
      if (Math.abs(Number(this.param.sum_vol2) - 100) < 0.001) {
        return true;
      }
      this.openPopup('제조조성의 합계가 100이 아닙니다.<br><br>샘플마스터 메뉴에서 질량비 계산을 수행하거나 실제조성, 제조조성을 수기로 입력해주세요.', undefined, undefined, 300, '<i class="mdi mdi-close-circle" style="color:#d32f2f; font-size:22px; vertical-align:text-bottom; margin-right:6px;"></i>알림');
      return false;
    },
    reset() {
      this.openPopup('취소하시겠습니까?', true, () => {
        this.loadData();
      });
    },
    save() {
      // 계산비(제조조성) 합계가 100이 아니면 완료 차단
      if (!this.checkCompositionSum()) {
        return;
      }
      if (this.param.sum_vol > 100 || this.param.sum_vol2 > 100) {
        this.openPopup('합계가 100이 넘습니다');
      } else {
        this.openPopup('저장하시겠습니까?', true, () => {
          this.param.memberId = this.id;
          // total은 항상 g. 사용자가 고른 표시 단위는 total_unit으로 저장하고 엑셀 산출에도 사용된다
          this.param.total_unit = this.totalUnit;
          produceReportUpdate(this.param)
            .then(() => {
              this.openPopup('저장되었습니다', false, () => {
                this.REMOVE_SELECT_MENU('reportDetail');
                this.SET_SELECT_MENU_TAB_BY_CODE('RMGMT');
              });
            })
            .catch(() => {
              this.openPopup('저장중 오류발생 : 관리자에게 문의하세요');
            });
        });
      }
    },
    async loadData() {
      if (this.isFetching) return;
      this.isFetching = true;

      try {
        this.param.lotNo = this.data.lotNo;
        this.param.code = this.data.code;
        const res = await produceReportDetail({
          ...this.param,
        });
        this.isDataLoaded = true;

        const response = res.data.data;
        if (response) {
          this.param.qty = response.qty;
          this.param.out_due_date = response.out_due_date;
          this.param.code_title = response.code_title;
          this.param.request_company = response.request_company;
          this.param.request_name = response.request_name;
          this.param.detail = response.items;
          this.param.delivery_type = response.delivery_type;
          this.param.request_code = response.request_code;
          this.param.packing = response.packing;
          this.param.analysis = response.analysis ? response.analysis : '특이사항 없음';
          this.param.delivery_etc = response.delivery_etc ? response.delivery_etc : '특이사항 없음';
          this.param.produce_etc = response.produce_etc ? response.produce_etc : '특이사항 없음';
          this.param.request_etc = response.request_etc ? response.request_etc : '특이사항 없음';
          this.param.sum_qty = response.sum_qty;
          this.param.sum_vol = response.sum_vol;
          this.param.sum_vol2 = response.sum_vol2;
          this.param.report_idx = response.report_idx;
          // 표시 단위 확정: 저장된 total_unit이 있으면 그것을, 없으면(NULL) 요청수량 기준 기본값
          this.totalUnit = response.total_unit ? response.total_unit : this.defaultTotalUnit();
          response.items.push({
            spec: 'SUM',
            vol: response.sum_vol,
            vol2: response.sum_vol2,
            qty: response.sum_qty,
          });
          _.each(response.items, v => {
            v['vol'] = Number(getNum(v['vol'])).toFixed(2);
            v['vol2'] = Number(getNum(v['vol2'])).toFixed(2);
            // 서버 투입량은 항상 g. 표시 단위로 환산 (하한/상한/실투입량은 g 유지)
            v['qty'] = this.qtyToDisplay(v['qty']);
            v['low'] = Number(getNum(v['low'])).toFixed(2);
            v['hig'] = Number(getNum(v['hig'])).toFixed(2);
            v['rqty'] = Number(getNum(v['rqty'])).toFixed(2);
          });
          // 초기 로딩 시 총량 세팅으로 watch가 도는 것을 막음 (watch는 nextTick에 실행되어 이 시점엔 이미 isFetching=false)
          this.suppressTotalWatch = true;
          this.param.total = response.total ? response.total : response.qty * 1000;
          this.syncTotalDisplay();
          this.$nextTick(() => {
            this.suppressTotalWatch = false;
          });
          this.$refs.reportDetailGrid.loadData(response.items);
          this.syncQtyHeader();
        }
      } catch (err) {
        this.error = err.message;
        this.openPopup('오류발생 : 관리자에게 문의하세요');
      } finally {
        this.isFetching = false;
      }
    },
    getSum(row, col) {
      return _.reduce(
        row,
        (a, v) => {
          a += Number(v[col]);
          return a;
        },
        0,
      ).toFixed(2);
    },
    changeData() {
      const row = this.$refs.reportDetailGrid.getJsonRows();
      if (row.length > 0) {
        const sumRow = row.pop(); // SUM 행의 나머지 칸(하한/상한/실투입량)을 잃지 않도록 보존
        this.param.detail = row;
        this.param.sum_vol = this.getSum(row, 'vol');
        this.param.sum_vol2 = this.getSum(row, 'vol2');
        this.param.sum_qty = this.qtyToDisplay(this.sumQtyGrams(row));
        row.push({
          ...sumRow,
          spec: 'SUM',
          vol: this.param.sum_vol,
          vol2: this.param.sum_vol2,
          qty: this.param.sum_qty,
        });
        this.$refs.reportDetailGrid.loadData(row);
      }
    },
    // total_unit이 없는(NULL) 건은 요청수량 기준으로 기본 단위 결정. 10kg 이상이면 kg
    defaultTotalUnit() {
      return Number(getNum(this.param.qty)) >= 10 ? 'kg' : 'g';
    },
    // 천단위 콤마 포맷 (표시 전용)
    formatNum(num, digits) {
      return Number(num).toLocaleString('ko-KR', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      });
    },
    // g로 보관된 총량의 표시값. kg는 소수 둘째자리, g는 정수
    totalToDisplay(grams) {
      if (grams === '' || grams === null || grams === undefined) return '';
      const g = Number(getNum(grams));
      return this.totalUnit === 'kg' ? this.formatNum(g / 1000, 2) : this.formatNum(Math.round(g), 0);
    },
    // g로 계산된 투입량의 표시값. 문서 규칙상 g/kg 모두 소수 둘째자리
    qtyToDisplay(grams) {
      const g = Number(getNum(grams));
      return (this.totalUnit === 'kg' ? g / 1000 : g).toFixed(2);
    },
    // 투입량 합계(g). 행마다 반올림한 값을 더하면 kg 표시에서 오차가 쌓여 SUM이 총량과 어긋나므로
    // (예: 0.0847→0.08) 반올림 전 값으로 합산하고 표시할 때 한 번만 반올림한다
    sumQtyGrams(rows) {
      const total = Number(getNum(this.param.total)) || 0;
      return _.reduce(rows, (a, r) => a + (Number(getNum(r.vol2)) * total) / 100, 0);
    },
    syncTotalDisplay() {
      this.totalDisplay = this.totalToDisplay(this.param.total);
    },
    // 그리드 투입량 헤더에 현재 단위 표기 (엑셀에는 단위를 표기하지 않음 - 요구사항)
    // 컬럼 name은 makeCell이 `${field}${v}` 로 만들어 'qty1'이므로 fieldName으로 찾아야 한다
    syncQtyHeader() {
      const gv = this.$refs.reportDetailGrid && this.$refs.reportDetailGrid.gv;
      if (!gv) return;
      const col = _.find(gv.getColumns(), c => c.fieldName === 'qty');
      if (!col) return;
      gv.setColumnProperty(col.name, 'header', { ...col.header, text: `투입량(${this.totalUnit})` });
    },
    // 입력값을 g로 환산해 param.total에 반영 (watch가 투입량 재계산). DB 저장값은 항상 g
    onTotalInput(val) {
      this.totalDisplay = val;
      // 표시값에 천단위 콤마가 들어가므로 숫자 변환 전에 제거해야 한다 (getNum은 '40,000'을 0으로 처리)
      const raw = String(val).replace(/,/g, '').trim();
      if (raw === '') {
        this.param.total = '';
        return;
      }
      const num = Number(getNum(raw));
      this.param.total = this.totalUnit === 'kg' ? Math.round(num * 1000) : Math.round(num);
    },
    // 단위 변환: 저장값(param.total, g)은 그대로 두고 총량/투입량 표시값만 환산
    toggleTotalUnit() {
      this.totalUnit = this.totalUnit === 'g' ? 'kg' : 'g';
      this.syncTotalDisplay();
      this.syncQtyHeader();
      this.recalcQtyByTotal();
    },
    // 총량(param.total) 변경 시 각 성분 투입량(qty)을 'vol2 × 총량 / 100'으로 즉시 재계산
    recalcQtyByTotal() {
      if (!this.$refs.reportDetailGrid) return;
      const rows = this.$refs.reportDetailGrid.getJsonRows();
      if (rows.length === 0) return;
      const sumRow = rows.pop(); // SUM 행 분리 (하한/상한/실투입량 등 나머지 칸은 그대로 유지해야 한다)
      const total = Number(getNum(this.param.total)) || 0;
      rows.forEach(r => {
        // 계산은 항상 g 기준(vol2 × 총량 / 100), 표시만 현재 단위로 환산
        r.qty = this.qtyToDisplay((Number(getNum(r.vol2)) * total) / 100);
      });
      this.param.detail = rows;
      this.param.sum_vol = this.getSum(rows, 'vol');
      this.param.sum_vol2 = this.getSum(rows, 'vol2');
      this.param.sum_qty = this.qtyToDisplay(this.sumQtyGrams(rows));
      rows.push({
        ...sumRow,
        spec: 'SUM',
        vol: this.param.sum_vol,
        vol2: this.param.sum_vol2,
        qty: this.param.sum_qty,
      });
      this.$refs.reportDetailGrid.loadData(rows);
    },
  },
  components: {
    RealGrid,
    SetPopup,
  },
  computed: {
    ...mapState('common', ['code']),
    // 화면 표기값. 원본 코드는 param.code 에 그대로 두고 여기서만 접미사를 붙인다.
    displayCodeGrade() {
      return displayCodeOf(this.data, this.param.code);
    },
    // 변환 버튼에는 '바뀔 단위'를 표기한다 (현재 g면 'kg로 변환')
    oppositeUnit() {
      return this.totalUnit === 'g' ? 'kg' : 'g';
    },
    // 표시 단위와 무관하게 DB에 저장되는 값은 항상 g
    totalDbText() {
      if (this.param.total === '' || this.param.total === null || this.param.total === undefined) return '-';
      return `${this.formatNum(Math.round(Number(getNum(this.param.total))), 0)} g`;
    },
  },
  watch: {
    // 사용자가 총량을 바꾸면 즉시 투입량 재계산 (초기 로딩 중에는 서버값 유지)
    'param.total'(newVal, oldVal) {
      if (this.isFetching) return;
      // 초기 로딩 등 프로그램적 세팅은 무시 (사용자 입력만 처리)
      if (this.suppressTotalWatch) return;
      // 되돌림으로 인한 재진입은 무시
      if (this.isRevertingTotal) {
        this.isRevertingTotal = false;
        return;
      }
      // 계산비(제조조성) 합계가 100이 아니면 총량 변경 차단 후 이전 값으로 되돌림
      if (!this.checkCompositionSum()) {
        this.isRevertingTotal = true;
        this.$nextTick(() => {
          this.param.total = oldVal;
          this.syncTotalDisplay();
        });
        return;
      }
      this.recalcQtyByTotal();
    },
  },
  mounted() {
    this.id = this.$store.state.member.userInfo.memberId;
    this.loadData();
  },
};
</script>
<style lang="scss">
.reportDetail {
  .v-input__slot {
    width: 100%;
  }
  .total-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .total-unit-btn {
    flex: 0 0 auto;
    height: 40px;
    text-transform: none; // 'g로 변환'이 'G로 변환'으로 대문자화되는 것 방지
  }
  .total-db-hint {
    margin-top: 2px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    white-space: nowrap;
  }
}
</style>
